export class NotificationsConfigurationEntity {

    allowNewTicketNotification!: boolean;
    allowTransferTicketNotification!: boolean;
    allowMessagesTicketNotification!: boolean;
    allowNewInternalChatNotification!: boolean;
    allowMessagesInternalChatNotification!: boolean;

    constructor({
                    allowNewTicketNotification,
                    allowTransferTicketNotification,
                    allowMessagesTicketNotification,
                    allowNewInternalChatNotification,
                    allowMessagesInternalChatNotification
                }: {
        allowNewTicketNotification: boolean;
        allowTransferTicketNotification: boolean;
        allowMessagesTicketNotification: boolean;
        allowNewInternalChatNotification: boolean;
        allowMessagesInternalChatNotification: boolean;
    }) {
        Object.assign(this, {
            allowNewTicketNotification,
            allowTransferTicketNotification,
            allowMessagesTicketNotification,
            allowNewInternalChatNotification,
            allowMessagesInternalChatNotification
        });
    }

    copyWith({
                 allowNewTicketNotification,
                 allowTransferTicketNotification,
                 allowMessagesTicketNotification,
                 allowNewInternalChatNotification,
                 allowMessagesInternalChatNotification
             }: {
        allowNewTicketNotification?: boolean;
        allowTransferTicketNotification?: boolean;
        allowMessagesTicketNotification?: boolean;
        allowNewInternalChatNotification?: boolean;
        allowMessagesInternalChatNotification?: boolean;
    }): NotificationsConfigurationEntity {
        return new NotificationsConfigurationEntity({
            allowNewTicketNotification: allowNewTicketNotification ?? this.allowNewTicketNotification,
            allowTransferTicketNotification: allowTransferTicketNotification ?? this.allowTransferTicketNotification,
            allowMessagesTicketNotification: allowMessagesTicketNotification ?? this.allowMessagesTicketNotification,
            allowNewInternalChatNotification: allowNewInternalChatNotification ?? this.allowNewInternalChatNotification,
            allowMessagesInternalChatNotification: allowMessagesInternalChatNotification ?? this.allowMessagesInternalChatNotification,
        })
    }
}
